import { Children, cloneElement } from 'react';
import { connectLocation } from "../../location/LocationConnectors";

import StickyNavBase from "../oc-sticky-nav";
import { anchor as stickyNavAnchor } from "../../helpers/sticky_nav";

const StickyNav = connectLocation(({ cta, children }) => {
  const mappedChildren = Children.map(children, child =>
    child && child.props && cloneElement(child, { anchor: stickyNavAnchor(child.props.heading) })
  )
  const items = mappedChildren.filter(({ props: { excludeFromStickyNav } }) => !excludeFromStickyNav).map(({ props: { heading, anchor } }) => ({ heading, anchor }));
  return (
    <StickyNavBase cta={cta} items={items}>
      {mappedChildren}
    </StickyNavBase>
  );
});

StickyNav.WrappedComponent.displayName = 'StickyNav'

export default StickyNav
